<template>
  <span class="build-timestamp" v-if="timestamp">{{ timestamp | moment('YYYY-MM-DD, dddd HH:mm') }}</span>
</template>

<script>
  export default {
    name: 'BuildTimestamp',
    computed: {
      timestamp() {
        const d = new Date(this.$store.state.app.buildTimestamp);
        if (d instanceof Date && !isNaN(d)) {
          return d
        }
        return undefined
      }
    }
  }
</script>

<style>
  .build-timestamp {
    font-size: 8px;
    color: transparent;
    position: absolute;
    right: 0;
    bottom: 0;
    cursor: default;
    padding: 3px;
    z-index: 10;
  }
</style>
